import { memo } from "react";
import { useSelector } from "react-redux";
import SoftBox from "components/SoftBox";
import { ThemedStartExecutionPlayIcon, ThemedClockMagicIcon } from "assets/CXFIcons/Static";
import { ThemedFlagIcon } from "assets/CXFIcons/Static";

const styles = {
  contentRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  iconWrapper: {
    display: "flex",
    //border: `1px solid #7443FF`,
    height: "30px",
    width: "30px",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "center"
  },
  nodeIcon: {
    fontSize: "16px !important",
    color: "#7443FF !important"
  }
};

const NodeIcon = ({ isStart }) => {
  const { isScheduledFlow } = useSelector((state) => state?.designer?.flows);

  return (
    <SoftBox sx={styles.contentRow}>
      <SoftBox sx={styles.iconWrapper}>
        {isStart ? (
          isScheduledFlow ? (
            <ThemedClockMagicIcon />
          ) : (
            <ThemedStartExecutionPlayIcon />
          )
        ) : (
          <ThemedFlagIcon />
        )}
      </SoftBox>
    </SoftBox>
  );
};

export default memo(NodeIcon);
